import sessionReader from '../../store/readHelpers/SessionReader';
import settingsReader from '../../store/readHelpers/SettingsReader';

const tableOfContentsSelector = {
    selectIsNavigationAllowed(settings) {
        if (sessionReader.isOneWayNavigationSupportedContext() && settingsReader.isOneWayNavigationEnabled()) {
            return false;
        }

        return settingsReader.allowNavigateBack(settings) || settingsReader.showAssessmentTrack(settings);
    },

    selectProps(state) {
        const {
            assessment,
            itemFlag: { flaggedItems },
            response,
            settings,
            toc,
            ui,
        } = state;

        return {
            assessment,
            flaggedItems,
            isNavigationAllowed: this.selectIsNavigationAllowed(settings),
            numberOfQuestions: toc.numberOfQuestions,
            questionsFilter: toc.filter,
            response,
            settings,
            ui,
        };
    },
};

export default tableOfContentsSelector;
